var map = {
	"./BadgeTemplates-01.svg": 2812,
	"./BadgeTemplates-02.svg": 2813,
	"./BadgeTemplates-03.svg": 2814,
	"./BadgeTemplates-04.svg": 2815,
	"./BadgeTemplates-05.svg": 2816,
	"./BadgeTemplates-06.svg": 2817,
	"./BadgeTemplates-07.svg": 2818,
	"./BadgeTemplates-08.svg": 2819,
	"./BadgeTemplates-09.svg": 2820,
	"./BadgeTemplates-10.svg": 2821,
	"./BadgeTemplates-11.svg": 2822,
	"./BadgeTemplates-12.svg": 2823,
	"./BadgeTemplates-13.svg": 2824,
	"./BadgeTemplates-14.svg": 2825,
	"./BadgeTemplates-15.svg": 2826,
	"./BadgeTemplates-16.svg": 2827,
	"./BadgeTemplates-17.svg": 2828,
	"./BadgeTemplates-18.svg": 2829,
	"./BadgeTemplates-19.svg": 2830,
	"./BadgeTemplates-20.svg": 2831,
	"./BadgeTemplates-21.svg": 2832,
	"./BadgeTemplates-22.svg": 2833,
	"./BadgeTemplates-23.svg": 2834,
	"./BadgeTemplates-24.svg": 2835,
	"./BadgeTemplates-25.svg": 2836,
	"./BadgeTemplates-26.svg": 2837,
	"./BadgeTemplates-27.svg": 2838,
	"./BadgeTemplates-28.svg": 2839,
	"./BadgeTemplates-29.svg": 2840,
	"./BadgeTemplates-30.svg": 2841,
	"./BadgeTemplates-31.svg": 2842,
	"./BadgeTemplates-32.svg": 2843,
	"./BadgeTemplates-33.svg": 2844,
	"./BadgeTemplates-34.svg": 2845,
	"./BadgeTemplates-35.svg": 2846,
	"./BadgeTemplates-36.svg": 2847,
	"./BadgeTemplates-37.svg": 2848,
	"./BadgeTemplates-38.svg": 2849,
	"./BadgeTemplates-39.svg": 2850,
	"./BadgeTemplates-40.svg": 2851,
	"./BadgeTemplates-41.svg": 2852,
	"./BadgeTemplates-42.svg": 2853,
	"./BadgeTemplates-43.svg": 2854,
	"./BadgeTemplates-44.svg": 2855,
	"./BadgeTemplates-45.svg": 2856,
	"./BadgeTemplates-46.svg": 2857,
	"./BadgeTemplates-47.svg": 2858,
	"./BadgeTemplates-48.svg": 2859,
	"./BadgeTemplates-49.svg": 2860,
	"./BadgeTemplates-50.svg": 2861,
	"./BadgeTemplates-51.svg": 2862,
	"./BadgeTemplates-52.svg": 2863,
	"./BadgeTemplates-53.svg": 2864,
	"./BadgeTemplates-54.svg": 2865,
	"./BadgeTemplates-55.svg": 2866,
	"./BadgeTemplates-56.svg": 2867,
	"./BadgeTemplates-57.svg": 2868,
	"./BadgeTemplates-58.svg": 2869,
	"./BadgeTemplates-59.svg": 2870,
	"./BadgeTemplates-60.svg": 2871,
	"./BadgeTemplates-61.svg": 2872,
	"./BadgeTemplates-62.svg": 2873,
	"./BadgeTemplates-63.svg": 2874,
	"./BadgeTemplates-64.svg": 2875,
	"./BadgeTemplates-65.svg": 2876,
	"./BadgeTemplates-66.svg": 2877,
	"./BadgeTemplates-67.svg": 2878,
	"./BadgeTemplates-68.svg": 2879,
	"./BadgeTemplates-69.svg": 2880,
	"./BadgeTemplates-70.svg": 2881,
	"./BadgeTemplates-71.svg": 2882,
	"./BadgeTemplates-72.svg": 2883,
	"./BadgeTemplates-73.svg": 2884,
	"./BadgeTemplates-74.svg": 2885,
	"./BadgeTemplates-75.svg": 2886,
	"./BadgeTemplates-76.svg": 2887,
	"./BadgeTemplates-77.svg": 2888,
	"./BadgeTemplates-78.svg": 2889,
	"./BadgeTemplates-79.svg": 2890,
	"./BadgeTemplates-80.svg": 2891,
	"./BadgeTemplates-81.svg": 2892,
	"./BadgeTemplates-82.svg": 2893,
	"./BadgeTemplates-83.svg": 2894,
	"./BadgeTemplates-84.svg": 2895,
	"./BadgeTemplates-85.svg": 2896,
	"./BadgeTemplates-86.svg": 2897,
	"./BadgeTemplates-87.svg": 2898,
	"./BadgeTemplates-88.svg": 2899,
	"./BadgeTemplates-89.svg": 2900,
	"./BadgeTemplates-90.svg": 2901,
	"./badge1.svg": 2902,
	"./badge10.svg": 2903,
	"./badge2.svg": 2904,
	"./badge3.svg": 2905,
	"./badge4.svg": 2906,
	"./badge5.svg": 2907,
	"./badge6.svg": 2908,
	"./badge7.svg": 2909,
	"./badge8.svg": 2910,
	"./badge9.svg": 2911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2811;